import { UsersFormStateTenantUserInvite } from './UsersFormStateTenantUserInvite';

export class UsersFormState {
  tenantUserInvite: UsersFormStateTenantUserInvite = new UsersFormStateTenantUserInvite();
}
